import React from "react";
import { TouchableOpacity, View } from "react-native";
import styled from "styled-components/native";
import { VDBText } from "@components/atoms";
import VDBIcon, { IconsVariant } from "@components/icons/VDBIcon";
import { VDBIcons } from "@utils/VDBIcons";
import { SpaceType } from "@components/atoms/Spacer/types";
import { useTypographyStore } from "@redux/slices/typographySlice";

export interface CollapsibleHeaderProps {
  title: string;
  isCollapsed: boolean;
  onToggle: () => void;
  selectedStyle?: any;
  theme: any;
}

const CollapsibleHeader: React.FC<CollapsibleHeaderProps> = ({
  title,
  isCollapsed,
  onToggle,
  selectedStyle,
  theme,
}) => {
  const typography = useTypographyStore();
  return (
    <HeaderContainer onPress={onToggle} activeOpacity={1}>
      <HeaderTitle>
        <VDBText type={typography["H3-M"]} isBold color={theme["core-05"]}>
          {title}
        </VDBText>
      </HeaderTitle>
      <View>
        <VDBIcon
          name={isCollapsed ? VDBIcons.ARROW_DOWN : VDBIcons.ARROW_UP}
          size={20}
          color={selectedStyle?.secondary}
          variant={IconsVariant.VDBCustom}
        />
      </View>
    </HeaderContainer>
  );
};

const HeaderContainer = styled(TouchableOpacity)`
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 14.5px ${SpaceType.Double}px;
`;

const HeaderTitle = styled.View`
  flex: 1;
`;

export default CollapsibleHeader;
